import { Navigate, Route } from 'react-router-dom';

import withRoutes, { RoutesMap } from './components/withRoutes';
import routesList from './guard/routeList';
import { memo } from 'react';
import NotFound from '#pages/not-found/NotFound';

const RouteMap = (): JSX.Element => {
  const routes = withRoutes(routesList);

  return (
    <RoutesMap routes={routes}>
      <Route path="/admin" element={<Navigate to="/admin/account" replace />} />
      <Route path="/user" element={<Navigate to="/user/profile" replace />} />
      <Route path="*" element={<NotFound />} />
    </RoutesMap>
  );
};

export default memo(RouteMap);
